import { useSyncExternalStore } from 'react';

// Simple hook to get current pathname without Next.js dependency
export var usePathname = function usePathname() {
  return useSyncExternalStore(function (callback) {
    if (typeof window === 'undefined') return function () {
      /* no-op */
    };
    window.addEventListener('popstate', callback);
    return function () {
      return window.removeEventListener('popstate', callback);
    };
  }, function () {
    return window.location.pathname;
  }, function () {
    return '';
  } // Server snapshot
  );
};